// Case-Sheet-specific dictation parsers. The generic helpers every dictated
// form uses (vText, vNum, appendText, …) live in lib/voiceFill.ts. Kept free of
// value imports so the Node unit tests can load it with type stripping alone.
import type { ChiefComplaint } from './types';

export const DURATION_UNITS = ['hours', 'days', 'weeks', 'months', 'years'] as const;
const COMPLAINT_RE = /^(.*?)[\s,:-]*(?:for|since|x|×)?\s*(\d+(?:\.\d+)?)\s*(hour|day|week|month|year)s?\b.*$/i;

/** "fever - 3 days; cough for 1 week; vomiting" → ChiefComplaint[]. */
export function parseComplaints(text: string): ChiefComplaint[] {
  return text.split(/[;\n]+/).map(part => part.trim()).filter(Boolean).map(part => {
    const m = part.match(COMPLAINT_RE);
    const name = m?.[1]?.trim().replace(/[\s,:-]+$/, '');
    if (!m || !name) return { text: part };
    const unit = DURATION_UNITS.find(u => u.startsWith((m[3] ?? '').toLowerCase()));
    return { text: name, duration_value: Number(m[2]), duration_unit: unit };
  });
}

